import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toast } from "sonner";

export default function AdminRoles() {
  const [data, setData] = useState(null);
  const [active, setActive] = useState(null);
  const [perms, setPerms] = useState({});

  const load = () => api.get("/roles").then(({ data }) => {
    setData(data);
    const first = data.roles.find((r) => r.name !== "super_admin") || data.roles[0];
    if (first) { setActive(first.name); setPerms(first.permissions || {}); }
  });
  useEffect(() => { load(); }, []);
  if (!data) return null;

  const selectRole = (name) => { const r = data.roles.find((x) => x.name === name); setActive(name); setPerms(r.permissions || {}); };
  const toggle = (mod, act) => setPerms((p) => {
    const cur = p[mod] || [];
    return { ...p, [mod]: cur.includes(act) ? cur.filter((a) => a !== act) : [...cur, act] };
  });
  const save = async () => { await api.put(`/roles/${active}`, { permissions: perms }); toast.success("Permissions updated"); };

  return (
    <div data-testid="admin-roles">
      <PageHeader title="Roles & Permissions" subtitle="Configure granular access for each role" action={<Button className="viriks-navy text-white" onClick={save} data-testid="save-perms">Save Changes</Button>} />
      <Tabs value={active || ""} onValueChange={selectRole} className="mb-6">
        <TabsList className="flex-wrap h-auto">{data.roles.filter((r) => r.name !== "super_admin").map((r) => <TabsTrigger key={r.name} value={r.name} data-testid={`role-tab-${r.name}`}>{r.label}</TabsTrigger>)}</TabsList>
      </Tabs>
      <div className="bg-white border border-border rounded-lg overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted"><tr><th className="p-3 text-left">Module</th>{data.actions.map((a) => <th key={a} className="p-3 capitalize">{a}</th>)}</tr></thead>
          <tbody>
            {data.modules.map((m) => (
              <tr key={m} className="border-t border-border">
                <td className="p-3 font-medium text-navy capitalize">{m.replace("_", " ")}</td>
                {data.actions.map((a) => (
                  <td key={a} className="p-3 text-center">
                    <input type="checkbox" checked={(perms[m] || []).includes(a)} onChange={() => toggle(m, a)} data-testid={`perm-${m}-${a}`} className="h-4 w-4 accent-[#ED1C24]" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
